import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import ProtectedRoute from "../components/base/ProtectedRoute";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Services from "../pages/services/page";
import CarePlans from "../pages/care-plans/page";
import ServiceAreas from "../pages/service-areas/page";
import Careers from "../pages/careers/page";
import Contact from "../pages/contact/page";
import ClientLogin from "../pages/client-login/page";
import FAQ from "../pages/faq/page";
import Resources from "../pages/resources/page";
import ClientDashboard from "../pages/dashboard/client/page";
import ClientAppointments from "../pages/dashboard/client/appointments/page";
import ClientMessages from "../pages/dashboard/client/messages/page";
import ClientSettings from "../pages/dashboard/client/settings/page";
import AdminDashboard from "../pages/dashboard/admin/page";
import AdminClients from "../pages/dashboard/admin/clients/page";
import AdminCaregivers from "../pages/dashboard/admin/caregivers/page";
import AdminAppointments from "../pages/dashboard/admin/appointments/page";
import AdminCarePlans from "../pages/dashboard/admin/care-plans/page";
import AdminSettings from "../pages/dashboard/admin/settings/page";
import Pricing from "../pages/pricing/page";
import Reviews from "../pages/reviews/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/services",
    element: <Services />,
  },
  {
    path: "/care-plans",
    element: <CarePlans />,
  },
  {
    path: "/pricing",
    element: <Pricing />,
  },
  {
    path: "/reviews",
    element: <Reviews />,
  },
  {
    path: "/faq",
    element: <FAQ />,
  },
  {
    path: "/resources",
    element: <Resources />,
  },
  {
    path: "/service-areas",
    element: <ServiceAreas />,
  },
  {
    path: "/careers",
    element: <Careers />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/client-login",
    element: <ClientLogin />,
  },
  {
    path: "/dashboard/client",
    element: (
      <ProtectedRoute allowedRoles={["client"]}>
        <ClientDashboard />
      </ProtectedRoute>
    ),
  },
  {
    path: "/dashboard/client/appointments",
    element: (
      <ProtectedRoute allowedRoles={["client"]}>
        <ClientAppointments />
      </ProtectedRoute>
    ),
  },
  {
    path: "/dashboard/client/messages",
    element: (
      <ProtectedRoute allowedRoles={["client"]}>
        <ClientMessages />
      </ProtectedRoute>
    ),
  },
  {
    path: "/dashboard/client/settings",
    element: (
      <ProtectedRoute allowedRoles={["client"]}>
        <ClientSettings />
      </ProtectedRoute>
    ),
  },
  {
    path: "/dashboard/admin",
    element: (
      <ProtectedRoute allowedRoles={["admin"]}>
        <AdminDashboard />
      </ProtectedRoute>
    ),
  },
  {
    path: "/dashboard/admin/clients",
    element: (
      <ProtectedRoute allowedRoles={["admin"]}>
        <AdminClients />
      </ProtectedRoute>
    ),
  },
  {
    path: "/dashboard/admin/caregivers",
    element: (
      <ProtectedRoute allowedRoles={["admin"]}>
        <AdminCaregivers />
      </ProtectedRoute>
    ),
  },
  {
    path: "/dashboard/admin/appointments",
    element: (
      <ProtectedRoute allowedRoles={["admin"]}>
        <AdminAppointments />
      </ProtectedRoute>
    ),
  },
  {
    path: "/dashboard/admin/care-plans",
    element: (
      <ProtectedRoute allowedRoles={["admin"]}>
        <AdminCarePlans />
      </ProtectedRoute>
    ),
  },
  {
    path: "/dashboard/admin/settings",
    element: (
      <ProtectedRoute allowedRoles={["admin"]}>
        <AdminSettings />
      </ProtectedRoute>
    ),
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
